'use client'
/***
 *
 * @file components/Media/index.tsx
 * @description Media component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Ingka Centres
 * @since 13 Feb 2024
 *
 */

import React, { useEffect, useState } from "react";
// import "./Media.scss";
import { getStruct } from "../../actions/media.action";
import ImageWrapper from "../ImageWrapper";
// import { useContentfulInspectorMode, useContentfulLiveUpdates } from "@contentful/live-preview/react";
// import { getStruct } from "./actions";

/**
 * Name: Media component
 * 
 * Description: This is a functional component to render media that is served by contentful
 * 
 * @param param0 
 * 
 * @example Parameter breakup
 * ```
 *  param0: {
 *    id: "",           
 *    data: {},      //the object containing the media content
 *    includes: "",  //includes property of the API response
 *  }
 * ```
 * @returns HTML content containing the media provided as input
 */
const Media = ({ id = "media-type", data, style = {}, includes, ...props }: any) => {
  const elData = data; //useContentfulLiveUpdates(data);
  // const inspectorModeProps = useContentfulInspectorMode();
  const [struct, setStruct]: any = useState();

  useEffect(() => {
    (async () => { setStruct(await getStruct()) })()
  }, [])

  return (
    <div 
      // {...(elData?.contentType !== 'Asset' ? inspectorModeProps({ fieldId: elData?.contentType || "baseplateMedia", entryId: elData?.id }) : {})} 
      id={id} 
      className={`Media-container ${elData?.title || ''}`} data-testid="Media"
      >
      {(elData?.content?.file || props?.media) &&
        <>
          {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
          {Array.isArray(elData?.content?.file) ? (
            elData?.content?.file?.map((mFile: any, i: number) => {
              return (
                <div key={`media-${mFile?.id}-${i}`} className="Media">
                  {mFile?.content?.file?.contentType?.includes("image/") &&
                    <ImageWrapper
                      alt={mFile?.title || "img"}
                      src={`${mFile?.content?.file?.url || props?.media}`}
                      sizes={mFile?.content?.file?.details?.size}
                      width={mFile?.content?.file?.details?.image?.width}
                      height={mFile?.content?.file?.details?.image?.height}
                      className={`${mFile?.content?.cssClass || ''}`}
                      style={{ maxWidth: "100%", height: "auto", ...style }}
                      loader={({ src }) => src}
                    />
                  }
                </div>
              )
            })
          ) : (
            <div className="">
              {(elData?.content?.file?.contentType?.includes("image/") || props?.media) &&
                <ImageWrapper
                  alt={elData?.title || "img"}
                  src={`${elData?.content?.file?.url || props?.media}`}
                  sizes={elData?.content?.file?.details?.size}
                  width={elData?.content?.file?.details?.image?.width}
                  height={elData?.content?.file?.details?.image?.height}
                  style={{ maxWidth: "100%", height: "auto", ...style }}
                  loader={({ src }) => src}
                />
              }
            </div>
          )}
        </>}
    </div>
  );
};

export default Media;
